// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1sy1a","upload":"Small_upload__qUPmH","imageWrap":"Small_imageWrap__3n-MV","removeBtn":"Small_removeBtn__1hQ7g"};